import Reset from "../../modules/Auth/components/Reset.jsx";

function PageReset() {
    return <><Reset/></>
}

export default PageReset;
